module.exports = __webpack_public_path__ + "static/images/callout_1.18a384b845497c4da7059b9743acf74a.jpg";